import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:slug",
    lazy: () => import("../pages/category/page").then(m => ({ element: <m.default /> })),
  },
  {
    path: "/comic/:id",
    lazy: () => import("../pages/comic/page").then(m => ({ element: <m.default /> })),
  },
  {
    path: "/about",
    lazy: () => import("../pages/about/page").then(m => ({ element: <m.default /> })),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
